var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _circle5, _circle6, _circle7, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3696,
    cy: 40.7407,
    r: 40.7407,
    fill: "#EBF1FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1114,
    cy: 25.9261,
    r: 2.46296,
    stroke: "#5290DC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.96296,
    cy: 14.074,
    r: 2.46296,
    stroke: "#5290DC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2227,
    cy: 25.9261,
    r: 2.46296,
    stroke: "#5290DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 12.4421V11.3757H14.4629V8.58911H15.5483V11.3757H18.3159V12.4421H15.5483V15.2224H14.4629V12.4421H11.6953Z",
    fill: "#5290DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6953 51.7012V50.6348H94.4629V47.8481H95.5483V50.6348H98.3159V51.7012H95.5483V54.4814H94.4629V51.7012H91.6953Z",
    fill: "#5290DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6582 36.8865V35.8201H97.4258V33.0334H98.5112V35.8201H101.279V36.8865H98.5112V39.6667H97.4258V36.8865H94.6582Z",
    fill: "#5290DC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.92535,
    cy: 38.5186,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0738,
    cy: 59.6299,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.0738,
    cy: 8.88897,
    r: 1.72222,
    stroke: "#5290DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 64.4814V28.4814L50 42.4814L79.5 28.4814L80.5 65.4814",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 65.4814H80.5",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65.4814H97",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 73.9814H24.5",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74.4814H40.5",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 74.4814H80",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55.4814H30",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 58.9814H37.5",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.9814L30 19.9814V9.98145H66V34.9814",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19.4814L79.5 27.4814",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44 8.98145L48.5 5.48145L53 8.98145",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.9814V19.4814",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27.9814H59.5",
    stroke: "#DADADA",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32.4814H59.5",
    stroke: "#DADADA",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 19.9814H50",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15.9814H43",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30.9814V64.9814H78V30.9814L49.5 43.4814L19 30.9814Z",
    fill: "#B8D7FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMailIcon);
export default __webpack_public_path__ + "static/media/checkMailIcon.1b77041bb730d930c992858378387105.svg";
export { ForwardRef as ReactComponent };